<template>
	<el-table
			v-if=" !loading  && tableData.length > 0"
			height="100%"
			:data="tableData"
			style="width: 100%">
		<el-table-column
				prop="loopName"
				label="名称"
		>
		</el-table-column>

		<el-table-column
				prop="node"
				label="分表用电量">
		</el-table-column>

		<el-table-column
				prop="val1"
				label="电损比例">
		</el-table-column>

		<el-table-column
				prop="val2"
				label="损耗分摊电量">
		</el-table-column>

	</el-table>
	<div v-else class="row-center tip">
		<img v-if="loading" src="../../../assets/img/loading.png" class="loading">
		<img v-else src="../../../assets/img/not_found_data.png" alt="">
	</div>
</template>

<script>
	import {floatFormat} from "../../../util/MathUtil"
	import {currentDay, monthDays} from "../../../util/DateUtil";
	import {LOOP_DIAGRAM_DATA_BY_DAY, LOOP_DIAGRAM_DATA_BY_MONTH, LOOP_DIAGRAM_DATA_BY_YEAR} from "../../../api/power";
	import exportExcel from "../../../util/excel";
	import Axios from "axios"
	import dict from "../../../util/dict"
	export default {
		props: {
			loops: Array,
			nodes: Array,
			range: String,
			date: Date
		},
		name: "Running",
		data() {
			return {
				currentCancelTokenSource: null,
				loading: false,
				show: false,
				allPoints: {},
				mapDate:[]
			}
		},
		mounted() {
			// this.mapDate = [{
			// 		loopName:"第一栋楼-1F",
			// 		node:"100kWh",
			// 		val1:"1.1",
			// 		val2:"10kWh"
			// 	}]
		},
		computed: {
			tableData() {
				let data = []
				this.loading = false
				data = this.mapDate
				return data
			},
		},
		methods: {
			
		},
		watch: {
			
		}
	}
</script>

<style scoped lang="less">
	.tip {
		width: 100%;
		height: 100%;
		font-size: 16rem;
		color: #8c939d;
	}

	.loading {
		width: 28rem;
		height: 28rem;
		animation: loading 1s linear infinite;
	}

	@keyframes loading {
		0% {
			transform: rotate(0);
		}
		100% {
			transform: rotate(360deg);
		}
	}
</style>